import Lazy from './Lazy';
export default Lazy;
